import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    InputLabel,
    Select,
    MenuItem,
    Link,
    Box,
    Typography,
    Divider,
    List,
    ListItem
} from "@material-ui/core";

import { AvailableLanguages, getCurrentLanguage } from "../../i18n";

import WelcomeMessage from "../WelcomeMessage/WelcomeMessage";

const AppDownloader = ({
    installee,
    languageIsSelectable,
    showMessage,
    match: {
        params: { accessKey }
    }
}) => {
    const { t } = useTranslation();
    const [language, setLanguage] = useState(getCurrentLanguage());
    const configuration = useSelector(state => state.configuration);


    useEffect(() => {
        setLanguage(getCurrentLanguage());
    }, [configuration]);

    return (
        <React.Fragment>
            <WelcomeMessage />
            <Typography variant="h4">{t(`Download.${installee}.title`)}</Typography>
            <Divider />
            {showMessage ? <Typography variant="caption">{t(`Download.${installee}.message`)}</Typography> : null}
            <Divider />
            <br />
            <Box>
                <Typography variant="h6">{t(`Download.${installee}.version`, { version: configuration.version })}</Typography>
                <Typography variant="h6">{t(`Download.${installee}.schema`, { schema: configuration.schema })}</Typography>
                <br />
                <Typography variant="h6">{t("Download.prerequisitesLabel")}</Typography>
                <List>
                    <ListItem>{t(`Download.${installee}.dotnetVersion`)}</ListItem>
                </List>
            </Box>
            <br />
            {languageIsSelectable ? (
                <Box>
                    <InputLabel htmlFor="language">
                        {t(`Download.language`)}
                        <Select id="language" value={language} onChange={e => setLanguage(e.target.value)}>
                            {AvailableLanguages.map(v => (
                                <MenuItem key={v} value={v}>
                                    {v}
                                </MenuItem>
                            ))}
                        </Select>
                    </InputLabel>
                </Box>
            ) : null}
            <br />
            <Link
                underline="always"
                href={`/api/download/${installee}installer?${accessKey ?
                    new URLSearchParams({
                    accessKey,
                    language
                    })
                    :
                    new URLSearchParams({
                    language
                    })}`
                }>
                {t("Download.download")}
            </Link>
        </React.Fragment>
    );
};

export default AppDownloader;
